/* import __COLOCATED_TEMPLATE__ from './set-ticket-custom-state.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type TicketStateService from 'embercom/services/ticket-state-service';
import { type MacroActionComponentArgs } from 'embercom/lib/inbox2/bulk-action-types';

interface Signature {
  Element: HTMLElement;
  Args: MacroActionComponentArgs;
}

export default class SetTicketCustomState extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare ticketStateService: TicketStateService;

  get ticketStates() {
    let liveTicketCustomStates = this.ticketStateService.liveTicketCustomStates;
    return this.ticketStateService.getGroupedCustomStatesForDropdown(liveTicketCustomStates, {
      showUserLabel: true,
      showRelatedTicketTypes: false,
      additionalItemClasses: 'max-w-48',
    });
  }

  get ticketCustomStateId() {
    return this.args.macroAction.data?.ticket_custom_state_id;
  }

  get label() {
    if (this.ticketCustomStateId === undefined) {
      return '';
    }
    let matchedState = this.ticketStateService.getTicketCustomStateById(this.ticketCustomStateId);
    return matchedState?.adminLabel || '';
  }

  get isInvalid() {
    if (this.args.forceInvalid) {
      return true;
    }
    return this.args.macroAction.isInvalid;
  }

  @action onSelectState(ticketCustomStateId: number) {
    this.args.macroAction.updateData({ ticket_custom_state_id: ticketCustomStateId });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Composer::MacroActions::SetTicketCustomState': typeof SetTicketCustomState;
    'inbox2/composer/macro-actions/set-ticket-custom-state': typeof SetTicketCustomState;
  }
}
